<template>
	<div class="report-container" id="warter_mark_show_talent">
    <div class="firstPage" id="warter_mark_show_firstPage">
      <div class="content" id="warter_mark_show_content" >
		<div class="report-content">
			<div class="report-header">BMW/MINI经销商情景模拟测试报告</div>
			<div class="split-line"></div>
			<div class="report-info">
				<span>候选人姓名：{{ reportItem.candidateName }}</span>
				<span>日期：{{ reportItem.examTime }}</span>
				<span>申请职位：{{ reportItem.jobTitle }}</span>
				<span>经销商：{{ reportItem.dealerName }}</span>
			</div>
			<div>
				<el-radio-group v-model="reportItem.result" style="pointer-events: none;">
					<el-radio label="PASS" >通过</el-radio>
					<el-radio label="NO_PASS">未通过</el-radio>
				</el-radio-group>
			</div>
			<div class="report-list">
				<div class="report-item" v-for="(item, name, index) in reportItem.examDetailMap" :key="index">
					<div class="grid-content bg-purple">
						<div class="report-title" :class="'report-title' + index">
							{{name}}
						</div>
						<div class="report-desc">最佳答案选择情况</div>
						<div class="report-subList">
							<div class="repost-subItem" v-for="(subItem, subIndex) in item" :key="subIndex">
								<span>{{ subItem.questionSubClass }}</span>
								<span style="margin-top:10px">
									<span v-if="subItem.isCorrect"><img alt="" src="@/assets/img/report/checked.png" style="display:inline-block;width:14px;" /></span>
									<span v-if="!subItem.isCorrect"><img alt="" src="@/assets/img/report/checkedN.png" style="display:inline-block;width:14px;" /></span>
								</span>
							</div>
						</div>
						<img alt="" src="@/assets/img/report/split.png" style="display:inline-block;width:100%" />
					</div>
				</div>
			</div>
			<div class="report-remark">
				<div class="left-content">
					<el-row>
						<el-col  :span="24">
							<el-row stripe class="repost-result">
								<el-col :offset="5" :span="6">总成绩</el-col>
								<el-col :span="12" style="font-size:18px;font-weight:600;text-align:center;">{{ reportItem.totalScore }}</el-col>
							</el-row>
							<el-row class="repost-result">
								<el-col :offset="5" :span="6">测试结果</el-col>
								<el-col :span="12" style="font-size:18px;font-weight:600;text-align:center;">
									<span v-if="reportItem.result == 'PASS'">通过</span>
									<span v-if="reportItem.result == 'NO_PASS'">未通过</span>
								</el-col>
							</el-row>
							<el-row class="repost-result">
								<el-col :offset="5" :span="6">风险提示</el-col>
								<el-col :span="12" style="text-align:center;">
									<span v-if="reportItem.risk == '低风险'"><img alt="" src="@/assets/img/report/icon3.png" style="margin-left:10px;" /></span>
									<span v-if="reportItem.risk == '中风险'"><img alt="" src="@/assets/img/report/icon2.png" style="margin-left:10px;" /></span>
									<span v-if="reportItem.risk == '高风险'"><img alt="" src="@/assets/img/report/icon1.png" style="margin-left:10px;" /></span>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</div>

				<div class="right-content">
					<el-row class="right-content-item">
						<el-col :offset="1" :span="22" class="report-desc">注明:</el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :span="1"><span class="report-dotted"></span></el-col>
						<el-col :span="22">总成绩=选择最佳答案的题目数量/总题目数量*100%</el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :span="1"><span class="report-dotted"></span></el-col>
						<el-col :span="22">推荐的通过标准线：50%</el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :span="1"><span class="report-dotted"></span></el-col>
						<el-col :span="22">风险提示说明：</el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :offset="1" :span="20">总成绩低于或等于30%：高风险
									<img alt="" src="@/assets/img/report/icon1.png" style="margin-left:10px;" /></el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :offset="1" :span="20">总成绩在30%~70%之间：中等风险
									<img alt="" src="@/assets/img/report/icon2.png" style="margin-left:10px;" /></el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :offset="1" :span="20">总成绩等于或超过70%：低风险
									<img alt="" src="@/assets/img/report/icon3.png" style="margin-left:10px;" /></el-col>
					</el-row>
					<el-row class="right-content-item">
						<el-col :span="1"><span class="report-dotted"></span></el-col>
						<el-col :span="22">本测试仅作为面试参考，其结果对专家测评结果没有决定性影响</el-col>
					</el-row>
				</div>

			</div>
			<div>
			<el-row style="margin:40px 0;">
				<el-col :offset="10" :span="3"><el-button type="primary" size="medium" style="width: 200px;height: 45px;font-size: 18px;" @click="tabRemove">确&nbsp;&nbsp;认</el-button></el-col>
			</el-row>
			</div>
		</div>
	</div>
	</div>
	</div>
</template>

<script>
import warterMark from '../../talent/warterMarkAcdc'
export default {
	components: {},
	data() {
		return {
			trainingRecordOptions: {},
			reportItem: {},
			isPass: 'PASS'
		};
	},
	computed: {},
	created() {
		console.log('created')
	},
	mounted() {
		// this.init()
		this.initData();
		this.setWarterMark()
	},
	watch: {
		// 监听,当路由发生变化的时候执行
		$route: {
			handler: function(val, oldVal) {
				if(val.query.bizId) {
					// console.log(val.query.bizId, oldVal.query.bizType)
					this.initData()
				}
			},
			// 深度观察监听
			deep: true
		}
	},
	methods: {
		initData() {
			// 获取地址栏参数
			// 链接示例:http://localhost:8001/#/sceneReport?bizId=ff80808172318b0e0173ad1656d15a2d&bizType=1316281770079326209
			var that = this;
			var bizId = this.$route.query.bizId;
			var bizType = this.$route.query.bizType;
			this.$request
				.get('/online/exam/scenarioExamReport?bizId=' + bizId + '&bizType=' + bizType)
				.then((res, total, code, data) => {
					if (code == 1) {
						that.reportItem = res;
						that.reportItem.examTime = that.formatDate(that.reportItem.examTime);
					} else {
						this.$message.warning(data.msg);
					}
				})
				.catch(error => {
					this.$message.warning(error);
				});
		},
		// 页面添加水印
		setWarterMark() {
			this.$request
				.post('/talent/talentpool/queryWarterMarkInfo', {})
				.then((res, total, code, data) => {
					this.dataListLoading = false;
					// console.log('水印');
					warterMark.set(data.data);
				})
				.catch(() => {
					this.dataListLoading = false;
				});
		},
		// 删除当前页面
		tabRemove () {
			let tabName = this.$store.state.contentTabsActiveName
			if (tabName === 'home') {
				return false
			}
			this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
			if (this.$store.state.contentTabs.length <= 0) {
				this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
				return false
			}
			// 当前选中tab被删除
			if (tabName === this.$store.state.contentTabsActiveName) {
				this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
			}
		},
		formatDate(val){
			let dates = val.split(' ');
			return dates[0];
		}
	}
};
</script>
<style lang="scss">
// @import "../../components/setStep/steps.css";
.report-container {
	font-family: Microsoft YaHei, sans-serif;
	width: 100%;
	margin: 0 auto;
	background: #ffffff;
	.report-content {
		margin-bottom: 20px;
		padding: 0 20px 20px 20px;
		.report-header {
			font-size: 24px;
			font-weight: bold;
			text-align: center;
			line-height: 42px;
			height: 42px;
			padding-top: 20px;
			margin: 20px auto 15px auto;
		}
		.split-line {
			width: 145px;
			height: 3px;
			background: #1d68d4;
			margin: 30px auto 0;
		}
		.report-info {
			margin: 30px auto 15px auto;
			font-weight: 500;
			span {
				margin-right: 10px;
			}
		}
		.report-list {
			display: flex;
			justify-content: space-between;
			height: 260px;
			margin-top: 10px;
			// overflow: hidden;
			.report-item {
				height: 100%;
				width: 24%;
				margin-right: 1%;
				float: left;
				&:last-child {
					margin-right: 0;
				}
			}
			.report-title{
				height: 85px;
				line-height: 85px;
				width: 100%;
				color: #ffffff;
				font-size: 20px;
				font-weight: 600;
				text-align: center;
				&.report-title0{
					background-color: #777b96;
				}
				&.report-title1{
					background-color: #93b0be;
				}
				&.report-title2{
					background-color: #aaa48e;
				}
				&.report-title3{
					background-color: #92a2bc;
				}
			}
			.report-desc{
				height: 55px;
				line-height: 55px;
				background-color: #f2f2f2;
				text-align: center;
				font-weight: 600;
				color: #666666;
				margin-top: 2px;
				border-left:1px solid  #d6d6d6;
				border-right: 1px solid  #d6d6d6;

			}
			.report-subList {
				width: 100%;
				height: 85px;
				white-space: nowrap;
				overflow-x: auto;
				overflow-y: hidden;
				border-left:1px solid  #d6d6d6;
				border-right: 1px solid  #d6d6d6;
				display: flex;
				.repost-subItem {
					text-align: center;
					border-right: 1px solid #d6d6d6;
					height: 60px;
					min-width: 80px;
					padding-top: 8px;
					margin: 10px 0;
					width: 80px;
					display: inline-block;
					flex: auto;
					&:last-child {
						border: none;
					}
				}
				span {
					display: block;
					width: 100%;
				}
			}
		}
		.repost-result {
			background: #f2f2f2;
			line-height: 40px;
			border-top: 1px solid #d6d6d6;
			&:nth-child(2) {
				background: #ffffff;
			}
			&:nth-child(3) {
				border-bottom: 1px solid #d6d6d6;
			}
		}
		.report-remark {
			width: 100%;
			position: relative;
			.left-content{
				padding-top: 40px;
				width: 42%;
				height: 220px;
			}
			.right-content{
				position: absolute;
				left: 48%;
				width: 53%;
				top: 10px;
				.right-content-item{
					margin-top: 2px;
					line-height: 20px;
					letter-spacing: 1px;
				}
			}
			.report-desc{
				font-weight:bold;font-size:18px;
			}
			.report-dotted{
				border-radius: 50%;
				background: #1d68d4;
				width: 3px;
				height: 3px;
				display: inline-block;
			}
		}
		.height-200 {
			height: 200px;
		}
		.height-230 {
			height: 230px;
		}
		.height-300 {
			height: 300px;
		}
	}
}
</style>
